import { Box, Text, Flex, Icon } from "@chakra-ui/react";
import { FaArrowUp, FaArrowDown, FaEquals } from "react-icons/fa";
import SystematicFactorsLineChart from "../../../components/charts/SystematicFactorsCharts/SystematicFactorsLineChart";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

// Reuse the same components from other sectors
const TrendIndicator = ({ direction }) => {
  switch (direction) {
    case "up":
      return <Icon as={FaArrowUp} color="green.500" />;
    case "down":
      return <Icon as={FaArrowDown} color="red.500" />;
    default:
      return <Icon as={FaEquals} color="gray.500" />;
  }
};

const ObservationText = ({ observation, isAuthenticatedUser }) => {
  if (observation.percentage === 0) {
    return (
      <Text
        fontSize="sm"
        color="gray.500"
        filter={isAuthenticatedUser ? "none" : "blur(2px)"}
      >
        No observation data available
      </Text>
    );
  }

  return (
    <Flex
      align="center"
      gap={2}
      filter={isAuthenticatedUser ? "none" : "blur(2px)"}
    >
      <TrendIndicator direction={observation.direction} />
      <Text fontSize="sm">
        Observed {observation.trend} of {observation.percentage}% over{" "}
        {observation.percentage === 100
          ? "all"
          : `${observation.percentage}/7`}{" "}
        years
      </Text>
    </Flex>
  );
};

const HR = ({ graphData, isAuthenticatedUser, observations }) => {
  return (
    <>
      {/* Total Employee Cost Chart */}
      <Box w="100%" position="relative">
        <Box
          position="absolute"
          top="2"
          right="2"
          zIndex="1"
          bg="whiteAlpha.800"
          px="2"
          borderRadius="md"
        >
          <ObservationText
            observation={observations?.totalEmployeeCost}
            isAuthenticatedUser={isAuthenticatedUser}
          />
        </Box>
        <SystematicFactorsLineChart
          data={graphData.totalEmployeeCost}
          heading="Total Employee Cost"
          dimension={{ width: "100%", height: 230 }}
        />
      </Box>
    </>
  );
};

export default HR;
